// src/com/user_info/UserInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * USER_INFO Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-09-19 09:59:40 using DbdbTap
 ************************************************ */

const USER_INFO_LIST_PART = gql`
fragment UserInfoListPart on UserInfo {
    userNid
    userId
    userName
    authClassId
    className
    dscId
    dscName
    dcCd
    dcName
    storeId
    storeName
    comId
    comName
    comDcCd
    zipCd
    addr
    telno
    mobile
    email
    useYn
    allDcYn
    handlerYn
    secuAgreeYn
    secuAgreeDate
    loginCnt
    regTypeCd
    regType
    loginTime
    logoutTime
    lastActTime
    regDate
    regUser
    regUserName
    classRank
}
`;

const USER_INFO_NO_LIST_PART = gql`
fragment UserInfoNoListPart on UserInfo {
    cvoUserId
    cvoToken
    viewLevel
    initLat
    initLon
    gcmId
    jsonMapConf
    auth2ndTime
    auth2ndTxt
}
`;


export const LIST_USER_INFO = gql`
${USER_INFO_LIST_PART}
query ListUserInfo {
    userInfoList {
        ...UserInfoListPart
    }
}
`;

export const GET_USER_INFO = gql`
${USER_INFO_LIST_PART}
${USER_INFO_NO_LIST_PART}
query GetUserInfo($userNid:Long!) {
    userInfoItem(userNid:$userNid) {
        ...UserInfoListPart
        ...UserInfoNoListPart
    }
}
`;

/*
    userInfoCheckUserId(userId: String!): UserInfo
*/
export const CHECK_USER_ID = gql`
query CheckUserId($userId:String!) {
    userInfoCheckUserId(userId: $userId) {
        userNid
    }
}
`;

// userInfoCheckUserIdUnsafe(userId: String!): UserInfo
export const CHECK_USER_ID_UNSAFE = gql`
query CheckUserIdUnsafe($userId:String!) {
    userInfoCheckUserIdUnsafe(userId: $userId) {
        userNid
    }
}
`;

export const ADD_USER_INFO = gql`
mutation AddUserInfo($userInfo:InputUserInfoAdd!) {
	userInfoAdd(userInfo: $userInfo) {
		ok
		message
	}
}
`;

export const EDIT_USER_INFO = gql`
mutation EditUserInfo($userInfo:InputUserInfoEdit!) {
	userInfoEdit(userInfo: $userInfo) {
		ok
		message
	}
}
`;

/*
userInfoEditMine(userInfo: InputUserInfoEditMine!): CommonResponse

input InputUserInfoEditMine {
    password: String!
	userName: String!
	zipCd: String
	addr: String
	telno: String
	email: String
}
*/
export const EDIT_MY_USER_INFO = gql`
mutation EditMyUserInfo($userInfo:InputUserInfoEditMine!) {
    userInfoEditMine(userInfo: $userInfo) {
        ok
        message
    }
}
`;

export const REMOVE_USER_INFO = gql`
mutation RemoveUserInfo($userInfo:InputUserInfoRemove!) {
	userInfoRemove(userInfo: $userInfo) {
		ok
		message
	}
}
`;

/*
input InputUserInfoUpload {
	userId: String!
	password: String!
	userName: String!
	authClassId: String!
	dscId: String!
	zipCd: String
	addr: String
	telno: String
}

# Batch upload response list's own item
type UserInfoUploadResponse {
	ok: Boolean!
	message: String
    userId: String!
}

type ResponseWithUserInfoResList {
    ok: Boolean!
    message: String
    list: [UserInfoUploadResponse]!
}
    userInfoUpload(userInfo: InputUserInfoUpload!): ResponseWithUserInfoResList
*/
// 업로드.
export const UPLOAD_USER_INFO = gql`
mutation UploadUserInfo($userInfoList:[InputUserInfoUpload]!) {
    userInfoUpload(userInfoList: $userInfoList) {
        ok
        message
        list {
            ok
            message
            userId
        }
    }
}
`;

/*

input InputUserInfoSetUsage {
    userNid: Long!
    useYn: String!
}
    userInfoSetUsage(userInfo: InputUserInfoSetUsage!): CommonResponse
*/
// 사용여부 설정.
export const SET_USAGE_USER_INFO = gql`
mutation SetUsageUserInfo($userInfo:InputUserInfoSetUsage!) {
    userInfoSetUsage(userInfo: $userInfo) {
        ok
        message
    }
}
`;

/*

input InputUserInfoSetHandler {
    userNid: Long!
    handlerYn: String!
}
    userInfoSetSecurityHandler(userInfo: InputUserInfoSetHandler!): CommonResponse

*/
// 정보취급자 설정.
export const SET_HANDLER_USER_INFO = gql`
mutation SetHandlerUserInfo($userInfo:InputUserInfoSetHandler!) {
    userInfoSetSecurityHandler(userInfo: $userInfo) {
        ok
        message
    }
}
`;

/*

input InputUserInfoChangePassword {
    userNid: Long!
    password: String!
    passwordConfirm: String!
}
    userInfoChangePassword(userInfo: InputUserInfoChangePassword!): CommonResponse
*/
// 사용자 암호 변경.
export const CHANGE_PASSWORD_USER_INFO = gql`
mutation ChangePasswordUserInfo($userInfo:InputUserInfoChangePassword!) {
    userInfoChangePassword(userInfo: $userInfo) {
        ok
        message
    }
}
`;

/*

input InputUserInfoChangeMyPassword {
    userNid: Long!
    password: String!
    newPassword: String!
    passwordConfirm: String!
}

    userInfoChangeMyPassword(userInfo: InputUserInfoChangeMyPassword!): CommonResponse
*/
// 내 암호 변경.
export const CHANGE_MY_PASSWORD_USER_INFO = gql`
mutation ChangeMyPasswordUserInfo($userInfo:InputUserInfoChangeMyPassword!) {
    userInfoChangeMyPassword(userInfo: $userInfo) {
        ok
        message
    }
}
`;

/*

input InputUserInfoChangePasswordOffline {
	userId: String!
    password: String!
    newPassword: String!
    passwordConfirm: String!
}

    userInfoChangePasswordOffline(userInfo: InputUserInfoChangePasswordOffline!): CommonResponse
*/
// 오프라인 사용자 암호 변경.
export const CHANGE_PASSWORD_OFFLINE_USER_INFO = gql`
mutation ChangePasswordOfflineUserInfo($userInfo:InputUserInfoChangePasswordOffline!) {
    userInfoChangePasswordOffline(userInfo: $userInfo) {
        ok
        message
    }
}
`;

/*

input InputUserInfoSetMapViewZero {
	viewLevel: Int!
	initLat: Float!
	initLon: Float!
}

userInfoSetMapViewZero(userInfo: InputUserInfoSetMapViewZero!): CommonResponse
*/
// 지도를 처음 열때의 사용자별 초기 위치, 줌레벨 설정.
export const SET_MAP_VIEW_ZERO_USER_INFO = gql`
mutation SetMapViewZeroUserInfo($userInfo:InputUserInfoSetMapViewZero!) {
    userInfoSetMapViewZero(userInfo: $userInfo) {
        ok
        message
    }
}
`;

// userInfoStartResetPasswordUsingEmail(userInfo: InputUserInfoStartResetPassword!): CommonResponse
export const START_RESET_USER_INFO_PASSWORD_USING_EMAIL = gql`
mutation UserInfoStartResetPasswordUsingEmail($userInfo: InputUserInfoStartResetPassword!) {
    userInfoStartResetPasswordUsingEmail(userInfo: $userInfo) {
        ok
        message
    }
}
`;
